const PERMISSION_KEY= "notification:notification_type_group";
const PAGE_URL = {
    NOTIFICATION_TYPE_GROUP_PAGE: "/admin/notification/notification-type-group"
}

export {PERMISSION_KEY, PAGE_URL}

